class NetatmoModule {
  id: string;
}

export default NetatmoModule;
